type StatProgressProps = {
  percentage: number;
  color: string;
};

export function StatProgress({ percentage, color }: StatProgressProps) {
  return (
    <div className="flex gap-2 items-center">
      <div className="bg-muted rounded-full flex-1">
        <div
          className={`h-1 rounded-full`}
          style={{ width: `${percentage}%`, backgroundColor: color }}
        />
      </div>
      <span className="text-xs font-semibold text-muted-foreground">
        {percentage % 1 !== 0 ? percentage.toFixed(1) : Math.floor(percentage)}%
      </span>
    </div>
  );
}
